var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"label relative inline-block pt-1 pr-2 mb-1 mr-1 rounded-lg font-sans font-semibold text-xs text-grey-darker hover:bg-white cursor-pointer",class:[
    { 'is-checked pl-2': !_vm.isChecked },
    { 'not-checked pl-5': _vm.isChecked },
  ]},[_vm._t("default"),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.isChecked},on:{"click":_vm.changed}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }